import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';

export default function GlobalSearch() {
  const [q, setQ] = useState('');
  const [results, setResults] = useState(null);
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const inputRef = useRef(null);

  useEffect(() => {
    function onKey(e) {
      if (e.key === '/' && !['INPUT', 'TEXTAREA'].includes(document.activeElement?.tagName)) {
        e.preventDefault();
        inputRef.current?.focus();
      }
      if (e.key === 'Escape') setOpen(false);
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  useEffect(() => {
    const val = q.trim();
    if (val.length < 2) { setResults(null); return; }
    const t = setTimeout(async () => {
      try {
        const r = await api.search(val);
        setResults(r);
        setOpen(true);
      } catch (e) {
        /* no-op */
      }
    }, 200);
    return () => clearTimeout(t);
  }, [q]);

  function go(path) { setOpen(false); setQ(''); nav(path); }

  const count = results ? results.rfqs.length + results.suppliers.length + results.customers.length + results.parts.length + (results.emails?.length || 0) + (results.quotes?.length || 0) : 0;

  return (
    <div className="global-search">
      <input
        ref={inputRef}
        className="input global-search-input"
        placeholder="Search RFQs, parts, quotes, emails ( / )"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        onFocus={() => q && setOpen(true)}
      />
      {open && results && count > 0 && (
        <div className="global-search-panel">
          {results.rfqs.length > 0 && (
            <div className="gsp-section">
              <div className="gsp-head">RFQs</div>
              {results.rfqs.map((r) => (
                <div key={r._id} className="gsp-item" onClick={() => go(`/rfq/${r._id}`)}>
                  <b className="mono">{r.rfqId}</b> · {r.title}
                </div>
              ))}
            </div>
          )}
          {results.parts.length > 0 && (
            <div className="gsp-section">
              <div className="gsp-head">Part numbers</div>
              {results.parts.map((p) => (
                <div key={p._id} className="gsp-item" onClick={() => go(`/rfq/${p.rfqId}/structure`)}>
                  <span className="mono">{p.partNumber}</span> · qty {p.quantity}
                </div>
              ))}
            </div>
          )}
          {results.suppliers.length > 0 && (
            <div className="gsp-section">
              <div className="gsp-head">Suppliers</div>
              {results.suppliers.map((s) => (
                <div key={s._id} className="gsp-item" onClick={() => go(`/suppliers/${s._id}`)}>{s.name}</div>
              ))}
            </div>
          )}
          {results.customers.length > 0 && (
            <div className="gsp-section">
              <div className="gsp-head">Customers</div>
              {results.customers.map((c) => (
                <div key={c._id} className="gsp-item" onClick={() => go(`/customers`)}>{c.name}</div>
              ))}
            </div>
          )}
          {results.quotes?.length > 0 && (
            <div className="gsp-section">
              <div className="gsp-head">Quoted parts</div>
              {results.quotes.map((q) => (
                <div key={q._id} className="gsp-item" onClick={() => q.rfqId && go(`/rfq/${q.rfqId}/compare`)}>
                  <span className="mono">{q.quotedPartNumber}</span>
                  {q.manufacturerQuoted && <> · {q.manufacturerQuoted}</>}
                  {q.supplierName && <> · <span style={{ color: 'var(--ink-500)' }}>{q.supplierName}</span></>}
                  {q.rfqRefId && <> · <span className="mono" style={{ color: 'var(--ink-500)' }}>{q.rfqRefId}</span></>}
                </div>
              ))}
            </div>
          )}
          {results.emails?.length > 0 && (
            <div className="gsp-section">
              <div className="gsp-head">Emails</div>
              {results.emails.map((e) => (
                <div key={e._id} className="gsp-item" onClick={() => go(`/mailbox${e.connectorId ? `?connectorId=${e.connectorId}` : ''}`)}>
                  <b>{e.fromName || e.fromAddress}</b>
                  <div style={{ fontSize: 12, color: 'var(--ink-500)' }}>{e.subject} — {e.snippet}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
